import Script from "next/script";
import React from "react";
import { loadTrustPilotWidgets } from "./TrustPilot.utils";

export const TrustPilot: React.FC = () => {
  return (
    <Script
      id="TrustpilotScript"
      data-testid="TrustpilotScript"
      type="text/javascript"
      src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
      strategy="afterInteractive"
      // TrustPilot is now available. Load trustpilot widgets if there are any
      onLoad={loadTrustPilotWidgets}
    />
  );
};
